/*
 * View for the topic status scheduled icon
 */

define([
  "marionette",
  "modules/topicsSplit/topic/topicScheduledStatus/template/topicScheduledStatusTemplate.html",
], function (Marionette, TopicScheduledStatusTemplate) {
  var TopicScheduledStatusView = {};

  TopicScheduledStatusView.topicScheduledStatusView = Marionette.ItemView.extend({
    template: TopicScheduledStatusTemplate,
    modelEvents: {
      change: "render",
    },
    triggers: {
      "click a": "edit:scheduled:status",
    },
  });

  return TopicScheduledStatusView;
});
